export enum SchoolType {

    elementary = 0,
    secondary = 1,
    special = 2
}
